import { Button, Modal } from "antd";
import React from "react";
import { IoCloseCircleOutline } from "react-icons/io5";

const DeletePopup = ({
  id,
  handleDelete,
  isCloseModalEnable = false,
  handleClose = () => {},
}) => {
  return (
    <Modal
      title="Confirm Deletion"
      open={true}
      onCancel={() => {
        if (isCloseModalEnable) {
          handleClose();
        } else {
          window.location.reload();
        }
      }}
      closeIcon={<IoCloseCircleOutline size={24} />}
      centered
      footer={[
        <Button
          key="cancel"
          onClick={() => {
            if (isCloseModalEnable) {
              handleClose();
            } else {
              window.location.reload();
            }
          }}
        >
          Cancel
        </Button>,
        <Button
          key="delete"
          type="primary"
          danger
          onClick={() => handleDelete(id)}
        >
          Delete
        </Button>,
      ]}
    >
      <p className="text-center">Are you sure you want to delete?</p>
    </Modal>
  );
};

export default DeletePopup;
